const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/png"] as const;

export const ACCEPTED_IMAGE_INPUT = [
  ".jpg",
  ".jpeg",
  ".png",
  ...ACCEPTED_IMAGE_TYPES,
].join(",");

export function isAcceptedImageFile(file: File): boolean {
  if (ACCEPTED_IMAGE_TYPES.includes(file.type as (typeof ACCEPTED_IMAGE_TYPES)[number])) {
    return true;
  }

  const normalizedName = file.name.toLowerCase();

  return normalizedName.endsWith(".jpg")
    || normalizedName.endsWith(".jpeg")
    || normalizedName.endsWith(".png");
}
